import { render, staticRenderFns } from "./CGender.vue?vue&type=template&id=5d54b564"
import script from "./CGender.vue?vue&type=script&lang=js"
export * from "./CGender.vue?vue&type=script&lang=js"
import style0 from "./CGender.vue?vue&type=style&index=0&id=5d54b564&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports